export default "__VITE_ASSET__84320f83__"